var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"14.0398","y":"11.4187","width":"34","height":"3","rx":"1.5","transform":"rotate(45 14.0398 11.4187)","fill":"#3C4652","key":0}),React.createElement("rect",{"x":"11.9186","y":"35.4602","width":"34","height":"3","rx":"1.5","transform":"rotate(-45 11.9186 35.4602)","fill":"#3C4652","key":1})]);
}

Close.defaultProps = {"width":"50","height":"49","viewBox":"0 0 50 49","fill":"none"};

module.exports = Close;

Close.default = Close;
